<!--
  Popover "Cambia operatore" — pattern Diakonix native (v2.11.0 J.1).
  Aperto via PopoverController Ionic; il contenuto è una mini-card centrata.
-->
<div class="co-card">
  <header class="co-header">
    <div class="co-icon">
      <i class="bx bx-transfer-alt"></i>
    </div>
    <div class="co-titles">
      <h2>Cambia Operatore</h2>
      <p>Scegli un nuovo operatore per la preparazione dell'ordine.</p>
    </div>
  </header>

  <div class="co-body">
    @if (loading) {
      <div class="co-loading">
        <i class="bx bx-loader-alt bx-spin"></i>
        Caricamento operatori...
      </div>
    } @else {
      <label class="co-field">
        <span class="co-field-label">Operatore</span>
        <select
          class="co-select"
          [value]="selectedAccountId ?? ''"
          (change)="onSelectOperator($any($event.target).value)"
        >
          <option value="">Seleziona un operatore...</option>
          @for (op of formattedOperators; track op.account_id) {
            <option [value]="op.account_id">{{ op.full_name }}</option>
          }
        </select>
      </label>
    }
  </div>

  <footer class="co-actions">
    <button
      type="button"
      class="co-btn co-btn--confirm"
      [disabled]="!selectedAccountId || submitting || loading"
      (click)="changeOperator()"
    >
      @if (submitting) {
        <i class="bx bx-loader-alt bx-spin"></i>
        Attendi...
      } @else {
        <i class="bx bx-check"></i>
        Cambia
      }
    </button>

    <button
      type="button"
      class="co-btn co-btn--cancel"
      (click)="cancel()"
    >
      <i class="bx bx-x"></i>
      Annulla
    </button>
  </footer>
</div>
